module.exports = __webpack_public_path__ + "media/packs/images/flags/HN-4fe977f223504758b5fe06edfc4e8251.svg";